"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var sitecore_jss_1 = require("@sitecore-jss/sitecore-jss");
var utils_1 = require("../utils");
var getEditableWrapper = function (editableMarkup, createElement) {
    // create an inline wrapper and use dangerouslySetInnerHTML.
    // if we try to parse the EE value, the parser may strip invalid or disallowed attributes from html elements - and EE uses several
    return createElement('span', {
        class: 'sc-image-wrapper',
        domProps: { innerHTML: editableMarkup },
    });
};
var getImageAttrs = function (_a, imageParams, mediaUrlPrefix) {
    var src = _a.src, srcSet = _a.srcSet, otherAttrs = __rest(_a, ["src", "srcSet"]);
    if (!src) {
        return null;
    }
    var newAttrs = __assign({}, otherAttrs);
    // update image URL for jss handler and image rendering params
    var resolvedSrc = sitecore_jss_1.mediaApi.updateImageUrl(src, imageParams, mediaUrlPrefix);
    if (srcSet) {
        // replace with HTML-formatted srcset, including updated image URLs
        newAttrs.srcSet = sitecore_jss_1.mediaApi.getSrcSet(resolvedSrc, srcSet, imageParams, mediaUrlPrefix);
    }
    else {
        newAttrs.src = resolvedSrc;
    }
    return newAttrs;
};
// custom comment to enable eslint vue plugin for Vue components as objects: https://github.com/vuejs/eslint-plugin-vue#attention
// @vue/component
exports.Image = {
    functional: true,
    props: {
        media: { type: Object, required: true },
        editable: { type: Boolean, default: true },
        imageParams: { type: Object, default: function () { return ({}); } },
        mediaUrlPrefix: { type: RegExp, default: undefined },
    },
    // Need to assign `any` return type because Vue type definitions are inaccurate.
    // The Vue type definitions set `render` to a return type of VNode and that's it.
    // However, it is possible to return null | string | VNode[] | VNodeChildrenArrayContents.
    render: function (createElement, context) {
        var _a = context.props, media = _a.media, editable = _a.editable, imageParams = _a.imageParams, mediaUrlPrefix = _a.mediaUrlPrefix;
        var contextAttrs = context.data.attrs;
        if (!media || (!media.editable && !media.value && !media.src)) {
            return null;
        }
        // we likely have an experience editor value, should be a string
        if (editable && media.editable) {
            var foundImg = sitecore_jss_1.mediaApi.findEditorImageTag(media.editable);
            if (!foundImg) {
                return getEditableWrapper(media.editable, createElement);
            }
            var imgAttrs = getImageAttrs(__assign(__assign({}, foundImg.attrs), contextAttrs), imageParams, mediaUrlPrefix);
            if (!imgAttrs) {
                return getEditableWrapper(media.editable, createElement);
            }
            var imgHtml = utils_1.generateHtmlTag('img', imgAttrs);
            var editableMarkup = media.editable.replace(foundImg.imgTag, imgHtml);
            return getEditableWrapper(editableMarkup, createElement);
        }
        // some wise-guy/gal is passing in a 'raw' image object value
        var img = media.src ? media : media.value;
        if (!img) {
            return null;
        }
        var attrs = getImageAttrs(__assign(__assign({}, img), contextAttrs), imageParams, mediaUrlPrefix);
        if (attrs) {
            // in functional components, context.data should be passed along to the
            // `createElement` function in order to retain attributes and events
            // https://vuejs.org/v2/guide/render-function.html#Passing-Attributes-and-Events-to-Child-Elements-Components
            var data = __assign(__assign({}, context.data), { attrs: attrs });
            return createElement('img', data);
        }
        return null; // we can't handle the truth
    },
};
